import {Component, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'sg-pc-dialog',
  templateUrl: './pc-dialog.component.html',
  styleUrls: ['./pc-dialog.component.scss']
})
export class PcDialogComponent {

  @Output() PcDialogChange = new EventEmitter();

}
